import React, { FC, useEffect, useState } from "react";
import ButtonCircle from "shared/Button/ButtonCircle";
import rightImg from "images/pool.jpg";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";
import Input from "shared/Input/Input";
import Modal from "shared/Modal";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { addSubscriber } from "actions/userActions";

export interface SectionSubscribe2Props {
  className?: string;
}

const SectionSubscribe2: FC<SectionSubscribe2Props> = ({ className = ""}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // const [openModal, setOpenModal] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");

  const { userSubscribe } = useSelector(
    (state: RootState) => state.userSubscribe
  );

  const { userInfo } = useSelector((state: RootState) => state.userInfo);

  const handleSubmit = (e: any) => {
    if (email) {
      dispatch(addSubscriber(email));
      setIsOpen(true);
    }
    e.preventDefault();
  }

  useEffect(() => {
    if (userInfo) {
      setEmail(userInfo.email);
    }
  }, [userSubscribe]);

  const handleSubscribeOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`nc-SectionSubscribe2 relative flex flex-col lg:flex-row lg:items-center ${className}`}
      data-nc-id="SectionSubscribe2"
    >
      <div className="flex-shrink-0 mb-10 lg:mb-0 lg:mr-10 lg:w-2/5">
        <h2 className="font-semibold text-4xl">Ikuti Perkembangan Kami</h2>
        <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
        Tinggalkan emailmu dan nantikan update terbaru dari Rentrips.id
        </span>
        <ul className="space-y-4 mt-10">
          <li className="flex items-center space-x-4">
            <Badge name="01" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
              Promo Menarik
            </span>
          </li>
          <li className="flex items-center space-x-4">
            <Badge color="red" name="02" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
              Artikel Terbaru
            </span>
          </li>
        </ul>
        <form className="mt-10 relative max-w-sm" onSubmit={handleSubmit}>
          <Input
            required
            aria-required
            placeholder="Masukkan Email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
            }}
          />
          <ButtonCircle
            type="submit"
            className="absolute transform top-1/2 -translate-y-1/2 right-1">
            <i className="las la-arrow-right text-xl"></i>
          </ButtonCircle>
        </form>
      </div>
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
      <Modal
        open={isOpen}
        handleOpen={handleSubscribeOpen}
        title={`Berhasil Terdaftar`}
      >
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        <h1 className="mt-3  text-neutral-900 dark:text-white text-xl">
        Terima kasih sudah bersedia mengikuti perkembangan kami. Nantikan info menari selanjutnya!
        </h1>
        <div className="mt-6">
          <ButtonPrimary
            onClick={() => {
              setIsOpen(false);
            }}
          >
            OK
          </ButtonPrimary>
        </div>
      </Modal>
    </div>
  );
};

export default SectionSubscribe2;
